import { createFeatureSelector } from '@ngrx/store';
import { Map } from 'immutable';

import { Loadable } from '®shared/data';
import { ListItem } from '®shared/reading-list/models';

export const STATE_FEATURE_ITEM_RESOLVER_STORE = 'itemResolverStore';

export type LoadableItem = Loadable<ListItem>;
export type ItemsById = Map<string, LoadableItem>;

export type ItemResolverStoreState = {
  draftItemsById: ItemsById;
  publishedItemsById: ItemsById;
};

export const ITEMS_BY_ID_INITIAL_STATE: ItemsById = Map<string, LoadableItem>();
export const ITEM_RESOLVER_STORE_INITIAL_STATE: ItemResolverStoreState = {
  draftItemsById: ITEMS_BY_ID_INITIAL_STATE,
  publishedItemsById: ITEMS_BY_ID_INITIAL_STATE,
};

export function getInitialItemResolverStoreState(): ItemResolverStoreState {
  return ITEM_RESOLVER_STORE_INITIAL_STATE;
}

export const selectItemResolverStoreState =
  createFeatureSelector<ItemResolverStoreState>(
    STATE_FEATURE_ITEM_RESOLVER_STORE,
  );
